import { render, staticRenderFns } from "./EnacAtplDashboardRegistrations.vue?vue&type=template&id=30dfbaed"
import script from "./EnacAtplDashboardRegistrations.vue?vue&type=script&lang=js"
export * from "./EnacAtplDashboardRegistrations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports